<template>
<div class="barcode-merge">
       <el-dialog
        :visible.sync="listDialogVisible"
         width='70%'
         title="节点列表"
     >
     <!-- :before-close="cancelCheck" -->
        <m-table
            ref="RegistrationTable"
            :pageTotal="pageTotal"
            :tableData="listData"
            :config="nodeConfig"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @search="search"
            @onSearchDataChange="onSearchDataChange"
            @onSelectionChange="onSelectionChange">
        </m-table>
        <span slot="footer" class="dialog-footer">
            <el-button @click="listDialogVisible = false" size="small" type="">
                取 消
            </el-button>
            <el-button @click="submit" size="small" type="primary">
                确 定
            </el-button>
        </span>
    </el-dialog>
</div>

</template>

<script>
import mTable from '@/modules/sn/components/IdentityComponentCopy/Main';
import { nodeConfig } from './nodeConfig.js';
import { nodeNotAddScene } from '../../../../api/systemManagementApi';
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
export default {
    name: 'nodeSave',
    components: { mTable },
    data() {
        return {
            nodeConfig,
            listData: [],
            listDialogVisible: false,
            stepDtoList: [],
            pageTotal: 0,
            searchData: {},
            nodeCode: ''
        };
    },

    mounted() {

    },
    computed: {
        ...mapGetters(['currentTenant'])
    },
    watch: {
          listDialogVisible(val) {
            if (!val) {
                this.nodeCode = '';
                this.stepDtoList = [];
                this.$refs.RegistrationTable.restSearchForm();
            }
          }
    },
    methods: {
        onSearchDataChange(data) {
            this.searchData = data;
        },
        pageChange(pageNo) {
            this.nodeConfig.page.pageNo = pageNo;
            this.search(this.searchData);
        },
        sizeChange(pageSize) {
            this.nodeConfig.page.pageNo = 1;
            this.nodeConfig.page.pageSize = pageSize;
            this.search(this.searchData);
        },
        // 查询
        search(data) {
            this.stepDtoList = [];
            this.getStepData(data);
        },
        onSelectionChange(data) {
            this.stepDtoList = data;
        },
        open(nodeCode) {
            this.listDialogVisible = true;
            this.nodeCode = nodeCode;
            this.search(this.searchData);
        },
        // 查询未添加到节点的步骤列表
        async getStepData(data) {
            const params = cloneDeep(data);
             Object.keys(params).forEach(item => {
                if (!params[item]) {
                    delete params[item];
                }
            });
            params.sceneCode = this.nodeCode;
            params.tenantCode = this.currentTenant.tenantCode;
            params.pageSize = this.nodeConfig.page.pageSize;
            params.pageNo = this.nodeConfig.page.pageNo;
            const res = await nodeNotAddScene(params);
            if (res.code + '' === '0' && res.data) {
                this.pageTotal = res.data.totalCount;
                this.listData = res.data.list;
            }
        },
        submit() {
            this.listDialogVisible = false;
            this.$emit('nodeSubmit', this.stepDtoList);
        }
    }
};
</script>

<style lang="less" scoped>
.barcode-merge {
    /deep/ .nPanel-1{
        width: 100% !important;
        .el-table {
        height: 400px !important;
        }
    }
}
</style>